import axios from "axios";
import { GURL } from "./global";

export const SendMail = (model) => {
  const url = `${GURL}/Commiunication/v1/Mail/Send`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(url, model);
};


export const GetVisit = () => {
  const url = `${GURL}/Setting/v1/Visit/GetVisit`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};


export const AddVisit = () => {
  const url = `${GURL}/Setting/v1/Visit/Add`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(url, {});
};
